import React, { useEffect, useState } from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { apiLink } from "../../helpers/constantVariables";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import HelpCenter from "../reusble_components/helpCenter";
import Footer from "./Footer";
import {
  getclusterbyDomain,
  getLogoForWhiteLabeling,
} from "../../services/white_label";

import Register from "../dashboard/register";
import {
  getDataFromLocalStorage,
  removeDataFromLocalStorage,
} from "../../services/localStorage";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import NewPlatformPopup from "../reusble_components/popup/NewPlatformPopup";
import { useStores } from "../../store";

export default function SignupWithGoogle() {
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [showTermAndConditions, setshowTermAndConditions] = useState(false);
  const [register, setRegister] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(false);
  const [showNewPlatformPopup, setShowNewPlatformPopup] = useState(false);
  const [newUserDetails, setnewUserDetails] = useState({});
  const [rcode, setRcode] = useState("");
  const checkForTheUserCredentials = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const user_google = JSON.parse(localStorage.getItem("user_google"));
    if (user) {
      loginUser(user_google?.email, user_google?.sub, user_google?.name);
      console.log(user);

      return navigateUsingRole(user?.role?.role);

      // navigate("/dashboard/settings");
    } else if (user_google) {
      loginUser(user_google?.email, user_google?.sub, user_google?.name);
    }
  };

  const { UserStore } = useStores();

  useEffect(() => {
    checkForTheUserCredentials();
    gettingParmsFromUrl();
  }, []);
  var referal = false;
  const gettingParmsFromUrl = () => {
    const url = window.location.href;
    const urlParams = new URL(url);
    const referalCode = urlParams.searchParams.get("refer");
    console.log(referalCode);
    setRcode(referalCode);
    if (referalCode) {
      setHasReferralCode(true);
    }
  };

  const [hasReferralCode, setHasReferralCode] = useState(referal);
  const group = new URLSearchParams(window.location.search).get("group");
  console.log("hello", group);
  const registerUser = async (name, mail, gId, pic) => {
    const body = {
      name: name,
      mail: mail,
      gId: gId,
      role: "647ce2e8c41bee677ea39fc4",
      pic: pic,
      rCode: rcode,
    };

    if (!localStorage.getItem("register")) {
      try {
        setloading(true);
        let newBody = body;
        newBody = {
          ...newBody,
          cluster: getclusterbyDomain(),
        };
        axios
          .post(`${apiLink}/user/register?groupId=${group}`, newBody)
          .then((res) => {
            setloading(false);
            console.log(res);
            if (res.status === 200) {
              UserStore.setUserDetails(res?.data?.data);
              return;
            }
            alert("Something went wrong. Please try again later. error: 25");
          })
          .catch((err) => {
            setloading(false);
            console.log(err);
            alert("Something went wrong. Please try again later. error: 29");
          });
      } catch (error) {
        console.error(error);
        alert("Something went wrong. Please try again later. error: 33");
      }
    }
  };

  const navigateUsingRole = async (role) => {
    // get the redirect url from local storage

    /* ------------------- REDIRECT TO THE URL IF IT IS THERE ------------------- */
    const redirectUrl = await getDataFromLocalStorage("redirectUrl");
    console.log(redirectUrl);
    if (redirectUrl) {
      removeDataFromLocalStorage("redirectUrl");
      window.location.href = redirectUrl;
      return;
    }

    /* ----------------------------------- XXX ---------------------------------- */

    switch (role) {
      case "student":
        return navigate("/dashboard/dashboard");
      case "company":
      case "consultancy":
        return navigate("/company/dashboard");

      default:
        return navigate("/dashboard/dashboard");
        break;
    }
  };

  const loginUser = async (mail, gId, name, pic) => {
    const body = {
      mail: mail,
      gId: gId,
    };
    try {
      setloading(true);
      let newBody = body;
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };

      const response = await axios
        .post(`${apiLink}/user/login`, newBody)
        .then(async (res) => {
          setloading(false);
          console.log("id", res.data);
          if (res.status === 200) {
            UserStore.setUserDetails(res?.data?.data);

            console.log("in", group);

            console.log("id1", res?.data.data._id);
            if (group) {
              const resp = await axios
                .post(
                  `${apiLink}/user/add-user-to-group?userId=${res?.data.data._id}&groupId=${group}`,
                  {},
                )
                .then((result) => {
                  if (result.status === 200) {
                    alert("sucessfully added into the group");
                  }
                });
            }

            if (
              res?.data?.data?.role?.role === "student" &&
              getDomainForWhiteLabeling() === "app.reaidy.io"
            ) {
              setPendingNavigation(res?.data?.data?.role?.role);
              setShowNewPlatformPopup(true);
              return;
            }

            return navigateUsingRole(res?.data?.data?.role?.role);
            // return navigate("/dashboard/dashboard");
          }
          alert("Something went wrong. Please try again later. error: 47");
        })
        .catch((err) => {
          setloading(false);
          console.log(err);
          if (err.response.status === 404) {
            // registerUser(name, mail, gId, pic);

            setnewUserDetails({
              name: name,
              mail: mail,
              gId: gId,
              role: "647ce2e8c41bee677ea39fc4",
              pic: pic,
            });

            setshowTermAndConditions(true);

            // const wouldYoulikeToSignUp = window.confirm(
            //   "You are not registered yet. Would you like to sign up?"
            // );
            // if (wouldYoulikeToSignUp) {
            //   registerUser(name, mail, gId);
            // }
          }
        });
    } catch (error) {
      console.error(error);
    }
  };

  const onSuccessLogin = (response) => {
    const userObject = jwt_decode(response.credential);
    console.log(userObject);
    localStorage.setItem("user_google", JSON.stringify(userObject));
    loginUser(
      userObject?.email,
      userObject?.sub,
      userObject?.name,
      userObject?.picture,
    );
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => onSuccessLogin(tokenResponse),
    onError: (error) => {
      console.log(error);
    },
  });

  function submitButton() {
    return (
      <button
        disabled={!enableSubmit}
        className={`gil-reg text-lg ${
          enableSubmit ? "bg-primary" : " bg-slate-300"
        } text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full`}
        onClick={() => {
          if (hasReferralCode && rcode === "") {
            alert("Please enter a referral code");
            return;
          }
          setshowTermAndConditions(false);
          setRegister(true);
          registerUser(
            newUserDetails.name,
            newUserDetails.mail,
            newUserDetails.gId,
            newUserDetails.pic,
          );
        }}
      >
        Continue
      </button>
    );
  }

  const termsAndConditionsWithSubmitButton = () => {
    return (
      <div className="flex flex-col items-center justify-center md:justify-start w-[90%] lg:w-[50%] md:w-[50%] md:h-[20vh] md:space-y-3 ">
        <div className=" flex flex-col md:justify-between h-60">
          <div className="flex items-center space-x-2 text-xl pb-0 md:pb-2 lg:pb-2">
            <input
              type="checkbox"
              id="acceptTerms"
              className="text-primary h-5 w-5 "
              onChange={(e) => {
                setEnableSubmit(e.target.checked);
              }}
            />
            <label htmlFor="acceptTerms" className="flex gap-2 items-center">
              <p className="whitespace-nowrap">I accept the </p>
              <a
                href="https://www.reaidy.in/page-terms.html"
                target="_blank"
                className="text-primary hover:underline whitespace-nowrap"
              >
                Terms and Conditions
              </a>
            </label>
          </div>
          <div className="h-24 py-3">
            {/* <div className="flex space-x-4">
              <p>Do you Have a Referal Code</p>
              <label>
                <input
                  type="radio"
                  value="yes"
                  checked={hasReferralCode}
                  onChange={() => setHasReferralCode(true)}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  value="no"
                  checked={!hasReferralCode}
                  onChange={() => setHasReferralCode(false)}
                />
                No
              </label>
            </div> */}
            {hasReferralCode && (
              <div>
                <input
                  required
                  disabled={!enableSubmit}
                  type="text"
                  className="border-2 px-2 py-2 border-gray-800 rounded-lg opacity-75 tracking-[3px] border-opacity-50 mt-2"
                  placeholder="Referal code"
                  value={rcode}
                  onChange={(e) => {
                    setRcode(e.target.value);
                    console.log(rcode);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="w-[90%]">{submitButton()}</div>
      </div>
    );
  };

  const handleNewPlatformCancel = () => {
    setShowNewPlatformPopup(false);
  };

  const handleNewPlatformConfirm = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    localStorage.clear();
    if (pendingNavigation === "student") {
      window.location.href = `https://user.reaidy.io/${user._id}`;
      return;
    }
  };

  return (
    <>
      <NewPlatformPopup
        isOpen={showNewPlatformPopup}
        onClose={handleNewPlatformCancel}
        onConfirm={handleNewPlatformConfirm}
        onCancel={handleNewPlatformCancel}
      />
      {register ? (
        <>
          <Register />
          <HelpCenter position="/" />
        </>
      ) : (
        <div className="flex flex-col items-center justify-center mx-auto md:w-full lg:w-full w-[100%] min-h-screen bg-gray-100 gil-reg">
          <Loader loader={loading} />
          <img
            src={getLogoForWhiteLabeling()}
            className=" w-[300px] md:w-[300px] lg:w-[400px] object-cover mb-5 md:mt-auto"
            alt="logo"
          />
          <h1 className="text-3xl gil-bold mb-8">Sign up for an account</h1>
          {showTermAndConditions ? (
            termsAndConditionsWithSubmitButton()
          ) : (
            <GoogleLogin
              id="google-login"
              onSuccess={(credentialResponse) => {
                console.log(credentialResponse);
                onSuccessLogin(credentialResponse);
              }}
              onError={() => {
                console.log("Login Failed");
                alert("Login Failed");
              }}
            />
          )}

          {/* this is the UI button part starts */}

          {/* <div className="flex mt-5 bg-[#202126] cursor-pointer py-2 pl-10 pr-2 rounded-full relative justify-center" >
            <div className="bg-white mr-2 left-1 top-1 text-2xl absolute rounded-full p-[5px]">
            <FcGoogle className=""/>
            </div>
            <h1 className="text-base ml-2 text-white gil-med">Sign in with Google</h1>
          </div> */}
          {/* the UI  button part Ends */}
          <div className="md:block md:mt-auto flex items-center justify-center md:items-end">
            <Footer className="bg-blue-500 text-white p-6 w-full" />
          </div>
          {/* <HelpCenter position="/" /> */}
          {/* <button
        className="flex items-center bg-white border border-gray-300 rounded-xl px-6 py-4 shadow hover:shadow-md focus:outline-none"
        onClick={login}
      >
        <img
          src="https://github.com/spotmies/images/assets/63062130/6a19d364-9fae-4e55-9069-8b4e7924e124"
          className="object-cover h-6 w-6 mr-2"
          alt="logo"
        />
        <span>Continue with Google</span>
      </button> */}
        </div>
      )}
    </>
    // <div className="w-[95vw] h-[100vh] gil-reg">
    //   <div className="flex flex-row justify-center items-center h-full w-full ">
    //     <GoogleLogin
    //       onSuccess={(credentialResponse) => {
    //         console.log(credentialResponse);
    //         onSuccessLogin(credentialResponse);
    //       }}
    //       onError={() => {
    //         console.log("Login Failed");
    //         alert("Login Failed");
    //       }}
    //     />
    //   </div>
    // </div>
  );
}
